import { LeftRight } from "@/components/LeftRight.tsx";
import { type ConfiguredWSelectProps, WSelect } from "@/components/forms/WSelect.tsx";
import { WSelectWrapper } from "@/components/forms/WSelectWrapper.tsx";
import { ResourceIcon } from "@/components/icon/ResourceIcon.tsx";
import { type VirtualMachineLoc, vmQueryAtom } from "@/modules/compute/vmQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export interface AssignedToSelectParams {
    location: string;
    usedResourceUuids: string[];
}

export interface AssignedToSelectProps
    extends ConfiguredWSelectProps<VirtualMachineLoc, string>, AssignedToSelectParams {}

//#region Icons

function ShortInfo({ item }: { item: VirtualMachineLoc }) {
    return <span>{item.private_ipv4}</span>;
}

//#endregion

function AssignedToSelectCustom({ items, location, usedResourceUuids = [], ...props }: AssignedToSelectProps) {
    items = items.filter((item) => location === item.location && !usedResourceUuids.includes(item.uuid));

    return (
        <WSelect
            className="min-w-20em"
            aria-label="Select resource"
            items={items}
            getKey={(item) => item.uuid}
            getTextValue={(item) => item.name}
            searchItems
            {...props}
        >
            {(item) => (
                <LeftRight icon={<ResourceIcon item={item} />} title={item.name} right={<ShortInfo item={item} />} />
            )}
        </WSelect>
    );
}

export type AssignedToSelectLoaderProps = Omit<AssignedToSelectProps, "items">;

function AssignedToSelectLoader(props: AssignedToSelectLoaderProps) {
    const vms = useSuspenseQueryAtom(vmQueryAtom(props.location));

    return <AssignedToSelectCustom items={[...vms.values()]} {...props} />;
}

export function AssignedToSelect(props: AssignedToSelectLoaderProps) {
    return (
        <WSelectWrapper fallback={(renderProps) => <AssignedToSelectCustom {...props} {...renderProps} />}>
            <AssignedToSelectLoader {...props} />
        </WSelectWrapper>
    );
}
